import React from 'react';
import FaqItem from 'src/elements/faq/FaqItem';
import { ItemsContainer } from './FAQSection.styles';

interface FAQItem {
  question: string;
  answer: string;
}

interface FAQListProps {
  faqItems: FAQItem[];
}

const FAQList = ({ faqItems }: FAQListProps): JSX.Element => {
  const items = faqItems.map((faqItem) => {
    return (
      <FaqItem key={faqItem.question} question={faqItem.question} answer={faqItem.answer}/>
    );
  });

  return (
    <ItemsContainer>
      {items}
    </ItemsContainer>
  );
};

export default FAQList;
